import { createSlice } from '@reduxjs/toolkit';
import { getBillingData } from "./api";
import {BILLING_UNIT_TYPES} from "../../constants";

const toMonthDate = (date) => {
    let rowASplit = date.split(".")
    let dateA = new Date()
    dateA.setDate(1)
    dateA.setMonth(Number(rowASplit[0]) - 1)
    dateA.setFullYear(2000 + Number(rowASplit[1]))
    dateA.setHours(0, 0, 0, 0)
    return dateA
}

export const billingSlice = createSlice({
    name: 'billing',
    initialState: {
        loading: false,
        monthlyBilling: null,
        dailyBilling: null,
        totalBilling: {
            avg: 0,
            sessions: 0,
            seconds: 0,
        },
        unitType: BILLING_UNIT_TYPES.AI_UNIT,
    },
    reducers: {

    },
    extraReducers: {
        [getBillingData.pending]: (state, { payload }) => {
            console.log("saveVideoData.pending")
            // #region agent log
            fetch('http://127.0.0.1:7766/ingest/f79e61b8-6fbd-4b36-93e1-9879329baecb',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'26fe08'},body:JSON.stringify({sessionId:'26fe08',runId:'sdk-billing-nec-honda',hypothesisId:'H1,H2',location:'solo-dashboard/src/redux/billing/index.js:pending',message:'billing reducer pending',data:{previousLoading:state.loading},timestamp:Date.now()})}).catch(()=>{});
            // #endregion
            state.loading = true;
        },
        [getBillingData.rejected]: (state, action) => {
            console.log("saveVideoData.rejected")
            // #region agent log
            fetch('http://127.0.0.1:7766/ingest/f79e61b8-6fbd-4b36-93e1-9879329baecb',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'26fe08'},body:JSON.stringify({sessionId:'26fe08',runId:'sdk-billing-nec-honda',hypothesisId:'H1,H2,H3',location:'solo-dashboard/src/redux/billing/index.js:rejected',message:'billing reducer rejected',data:{error:action.error?{name:action.error.name,message:action.error.message}:null},timestamp:Date.now()})}).catch(()=>{});
            // #endregion
            state.loading = false;
        },
        [getBillingData.fulfilled]: (state, { payload }) => {
            console.log("getBillingData.fulfilled")
            // #region agent log
            fetch('http://127.0.0.1:7766/ingest/f79e61b8-6fbd-4b36-93e1-9879329baecb',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'26fe08'},body:JSON.stringify({sessionId:'26fe08',runId:'sdk-billing-nec-honda',hypothesisId:'H2,H3,H4',location:'solo-dashboard/src/redux/billing/index.js:fulfilled',message:'billing reducer fulfilled input',data:{payloadKeys:payload?Object.keys(payload):[],monthIsArray:Array.isArray(payload&&payload.month),dayIsArray:Array.isArray(payload&&payload.day),monthDates:payload&&Array.isArray(payload.month)?payload.month.map(item=>item.date):null,dayDates:payload&&Array.isArray(payload.day)?payload.day.slice(0,12).map(item=>item.date):null},timestamp:Date.now()})}).catch(()=>{});
            // #endregion
            const monthlyPayload = Array.isArray(payload.month) ? payload.month : [];
            const dailyPayload = Array.isArray(payload.day) ? payload.day : [];
            state.loading = false;
            state.monthlyBilling = monthlyPayload.map(item => {
                let dateA = toMonthDate(item.date)
                return {...item,
                    type: "month",
                    realDate: dateA,
                }
            }).sort((a, b) => a.realDate - b.realDate)
            state.dailyBilling = dailyPayload.slice().sort((a, b) => new Date(a.date) - new Date(b.date))
            state.totalBilling = payload.total || {
                avg: 0,
                sessions: 0,
                seconds: 0,
            }
            state.unitType = payload.unitType || BILLING_UNIT_TYPES.AI_UNIT
        },
    }
});

const { actions, reducer } = billingSlice;

export default reducer;
